import { Card } from 'component/Card'
import { Img } from 'component/Image'
import { Loader } from 'component/Loader/Loader'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { i18n, I18nKey } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Page } from 'page/Page/Page'
import { store } from 'store/store'
import css from './ComboScreen.module.scss'
import ProductActions from './ProductActions'

export const ComboScreen = observer(() => {
  const item = store.item
  const combo = store.comboItem
  const { identity_id } = store.profile
  const no_limit = !!identity_id && !store.available
  const exceededLimitType = store.exceededLimitType || ''
  const limitText = i18n(`LimitTextShot${exceededLimitType}` as I18nKey)
  const limitTextTryAgain = i18n(`LimitTextTryAgain${exceededLimitType}` as I18nKey)


  if (!item || !combo) {
    return <Page clear center>
      <Loader />
    </Page>
  }

  return (
    <Page clear tall>
      <Vertical
        center
        tall
        wide
        gap={24}
      >
        <Vertical wide gap={8}>
          <Typo upper center className={css.title}>
            {i18n('CreateYourStyle')}
          </Typo>
          <Typo center className={css.description} secondary>
            {i18n('TryOnItemsSeparatelyOrComplementThem')}
          </Typo>
        </Vertical>

        <Vertical wide gap={12}>
          <Space gap={16}>
            <Card className={css.itemCard}>
              <Img
                className={css.itemImage}
                src={item.image?.source}
              />
            </Card>
            <Card className={css.itemCard}>
              <Img
                className={css.itemImage}
                src={combo.image?.source}
              />
            </Card>
          </Space>

          <Space gap={16} wide top>
            <Vertical gap={4} wide top>
              {item.json.brand_name && (
                <Typo className={css.itemBrand}>{item.json.brand_name}</Typo>
              )}
              <Typo className={css.itemName}>{item.json.product_name}</Typo>
            </Vertical>
            <Vertical gap={4} wide top>
              {combo.json.brand_name && (
                <Typo className={css.itemBrand}>{combo.json.brand_name}</Typo>
              )}
              <Typo className={css.itemName}>{combo.json.product_name}</Typo>
            </Vertical>
          </Space>

          {!no_limit && (
            <Space gap={16} wide>
              <ProductActions type="main" />
              <ProductActions type="combo" />
            </Space>
          )}
        </Vertical>

        {no_limit && (
          <Vertical wide pad={12} gap={4} center className={css.limit}>
            <Typo center semi>{limitText}</Typo>
            <Typo center>{limitTextTryAgain}</Typo>
          </Vertical>
        )}
      </Vertical>
    </Page>
  )
})
